<template>
	<v-container class="mt-4 ml-2" fluid>
	  <v-row>
	  	<v-col cols="12">
	  		<v-card class="shadowCard">
	  		  <v-card-title primary-title>
	  		    <span class="text-subtitle-1">Grupos Sucursal</span>
	  		    <v-spacer></v-spacer>

            <v-btn 
              class="mr-2" 
              small dark color="green"
              @click="exportExcel( grupos  , 'CURSOS_ERP')"
              tile
            >
              <v-icon small>mdi-microsoft-excel</v-icon>
            </v-btn>

            <v-btn
              color="primary"
              dark
              class="text-capitalize"
              @click="initialize()"
              small
              tile
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>
          
	  		  <v-card-text>
	  		  	<v-row justify="end">
	  		  		<v-col cols="12" md="6">
	  		  			<v-text-field
	  		  			  name="name"
	  		  			  label="Buscar"
	  		  			  id="id"
	  		  			  filled
	  		  			  dense
	  		  			  hide-details
	  		  			  append-icon="mdi-magnify"
	  		  			  v-model="search"
	  		  			></v-text-field>
	  		  		</v-col>
	  		  	</v-row>
	  		    <v-row>
	  		    	<v-col cols="12">
							  <v-data-table
							    :headers="headers"
							    :items="grupos"
							    class="elevation-0"
							    :search="search"
							    :mobile-breakpoint="100"
			            dense
							  >
							    <!-- Valores que ocupan botons, chips, iconos, etc -->
							    <template v-slot:item.activo_sn="{ item }">
							      <v-chip 
							      	v-if="item.activo_sn == 1"
							      	small
							      	color="green"
							      	dark
							      >Si</v-chip>

							      <v-chip 
							      	v-else
							      	small
							      	color="error"
							      	dark
							      >No</v-chip>
							    </template>
							  

							    <template v-slot:item.actions="{ item }">

							    	<v-btn 
							    		color="orange" 
							    		x-small
							    		icon
							    		@click="editItemAlumnos(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-account</v-icon>
							    	</v-btn>

							    	<v-btn 
							    		color="blue" 
							    		x-small
							    		icon
							    		@click="alumnosAsistencia(item)"
							    		class="mr-2"
							    	>
								      <v-icon small>mdi-clipboard-account</v-icon>
							    	</v-btn>


							    </template>

							    <template v-slot:no-data>
							      <v-btn
							        color="primary"
							        @click="initialize"
							        small
							      >
							        Actualizar
							      </v-btn>
							    </template>

							  </v-data-table>
	  		    	</v-col>
	  		    </v-row>
	  		  </v-card-text>
	  		</v-card>
	  	</v-col>
	  </v-row>

    <!-- Ver los alumnos -->
	  <v-dialog
      v-model="dialogAlumnos"
      max-width="1000px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Lista de alumnos</span>
          <v-spacer></v-spacer>
          <span class="text-subtitle-1">
          	<strong>ID: {{ editedItem.idgrupos }}</strong>
          </span>
        </v-card-title>

        <v-card-text>
        	<v-row>
        		<v-col cols="12" md="8">
        			<v-autocomplete
			          filled
			          dense
			          clearable
			          v-model="alumno"
			          :items="alumnos"
			          label="Selecciona un alumno"
			          hide-details
			          return-object
			          item-text="nombre_completo"
			          item-value="idalumnos"
			        >
        				<template v-slot:append-outer>
		              <v-btn
		              	color="primary"
		              	@click="saveAlumno( )"
		              >
		              	<v-icon>mdi-plus</v-icon>
		              </v-btn>
		            </template>
        			</v-autocomplete>
        		</v-col>
        	</v-row>

          <v-row>
          	<v-col cols="12">
						  <v-data-table
						    :headers="headersAlumnos"
						    :items="inscritos"
						    class="elevation-0"
						    :mobile-breakpoint="100"
		            dense
						  >
						    <template v-slot:item.actions="{ item }">
						    	<v-btn 
						    		color="error" 
						    		x-small
						    		icon
						    		@click="deleteItemAlumnos(item)"
						    		class="mr-2"
						    	>
							      <v-icon small> mdi-delete</v-icon>
						    	</v-btn>
						    </template>

						    <template v-slot:no-data>
						      <v-btn
						        color="primary"
						        @click="initialize"
						        small
						      >
						        Actualizar
						      </v-btn>
						    </template>

						  </v-data-table>
  		    	</v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="closeAlumnos"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogAlumnosAsistencia"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="text-subtitle-1">Tomar asistencia</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text>
        	<v-row>
        		<v-col cols="12" md="8" lg="6">
        			<v-menu
				        ref="menu"
				        v-model="menu"
				        :close-on-content-click="false"
				        :return-value.sync="fecha_asistencia"
				        transition="scale-transition"
				        offset-y
				        min-width="auto"
				      >
				        <template v-slot:activator="{ on, attrs }">
				          <v-text-field
				            v-model="fecha_asistencia"
				            label="Fecha de asistencia"
				            append-icon="mdi-calendar"
				            readonly
				            v-bind="attrs"
				            v-on="on"
				            filled
				          ></v-text-field>
				        </template>
				        <v-date-picker
				          v-model="fecha_asistencia"
				          no-title
				          scrollable
				          :allowed-dates="allowedDates"
				          :min="fechaMin"
    							:max="fechaMax"
    							color="primary"
				        >
				          <v-spacer></v-spacer>
				          <v-btn
				            text
				            color="primary"
				            @click="menu = false"
				          >
				            Cancel
				          </v-btn>
				          <v-btn
				            text
				            color="primary"
				            @click="$refs.menu.save(fecha_asistencia),getAlumnos(grupo)"
				          >
				            Ok
				          </v-btn>
				        </v-date-picker>
				      </v-menu>

        		</v-col>
        	</v-row>

        	<v-row>
        		<v-col cols="12">
        			<v-radio-group
		            row
		            value="1"
		          >
		            <v-radio
		              color="green"
		              value="1"
		              label="Asistencia"
		            ></v-radio>
		            <v-radio
		              color="red"
		              value="1"
		              label="Falta"
		            ></v-radio>
          		</v-radio-group>
        		</v-col>
        	</v-row>
          <v-row>
          	<v-col cols="12">
						  <v-data-table
						    :headers="headersAlumnosAsistencia"
						    :items="listaalumnos"
						    :items-per-page="listaalumnos.length"
						    class="elevation-0"
						    hide-default-footer
						    :mobile-breakpoint="100"
						  >
						    <!-- Valor asistencia -->
						    <template v-slot:item.asistencia="{ item }">
						    	<div>
						    		<v-radio-group
				              row
				              v-model="item.valor_asistencia"
				            >
				              <v-radio
				                color="green"
				                :value="1"
				              ></v-radio>
				              <v-radio
				                color="red"
				                :value="2"
				              ></v-radio>
				            </v-radio-group>
						    	</div>
						    </template>
						  </v-data-table>

  		    	</v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            icon
            top
            absolute
            right
            @click="dialogAlumnosAsistencia = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

			  	<v-spacer></v-spacer>
			    <v-btn
			    	color="green"
	  				dark 
	  				block
	  				outlined
	  				@click="enviarAsistencias()" 
	  			>
	  				<v-icon small left>mdi-content-save</v-icon>
	  				<span >Guardar</span>
	  			</v-btn>
			  </v-card-actions>


        </v-card-actions>
      </v-card>
    </v-dialog>


    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>
<script>
import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'


  export default {

    mixins: [ validarErrores, funcionesExcel ],

  	components:{
      Alerta,
      carga,
    },

    data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialog: false,
      dialogDelete: false,
      
      editedIndex: -1,

      editedItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      defaultItem: {
        idgrupos:0,
				idplanteles:null,
				idhorarios:null,
				idcursos:null,
				cupo:null,
				idmaestros:null,
				fechainicio:null,
				fechafinal:null,
				deleted:0,
				fecha_creacion:null,
      },

      // Filtros: 
      incio:null,
			fin:null,

      // tabla
			search:'',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      cursos: [],

      headers: [
        { text: 'ID'         , value: 'idgrupos'       },
        { text: 'Plantel'    , value: 'plantel'        },
        { text: 'Curso'      , value: 'curso'          },
        { text: 'Horario'    , value: 'horario'        },
        { text: 'Inicia'     , value: 'fechainicio'    },
        { text: 'Termina'    , value: 'fechafinal'     },
        { text: 'Fecha Alta' , value: 'fecha_creacion' },
        { text: 'Actions'    , value: 'actions', sortable: false },
      ],

      headersAlumnos: [
        { text: 'ID'       , value: 'idgruposalumnos'  },
        { text: 'Alumno'   , value: 'alumno'           },
        { text: 'Teléfono' , value: 'telefono'         },
        { text: 'Edad'     , value: 'edad'             },
        { text: 'Correo'   , value: 'correo'           },
        { text: 'Actions'  , value: 'actions', sortable: false },
      ],

      headersAlumnosAsistencia: [
        { text: 'Alumno'        , value: 'alumno'    , class: 'secondaryText--text text-caption sizeFont' },
        { text: 'Asistencia'    , value: 'asistencia', class: 'secondaryText--text text-caption sizeFont' },
      ],

      cursos:[],
      horarios:[],
      planteles:[],
      alumnos:[],
      inscritos:[],
      teachers:[],
      dialogAlumnos:false,
      alumno: null,

      deleteAlumno: {
        idgruposalumnos:0,
        deleted: 0
      },

      listaalumnos:[],

      dialogDeleteAlumno: false,
      dialogAlumnosAsistencia: false,
      fecha_asistencia: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			menu: false,
      fechasHabiles:["2025-04-23"],
			fechaMin:null,
			fechaMax:null
    }),

    computed: {
    	...mapGetters('login',['getdatosUsuario']),
      formTitle () {
        return this.editedIndex === -1 ? 'Agregar grupo' : 'Editar grupo'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },

      dialogAlumnos ( val ){
      	val || this.closeAlumnos( )
      },

      fecha_asistencia( val ){
      	this.alumnosAsistencia( this.editedItem )
      }

    },

    async created () {
    	console.log( this.getdatosUsuario )
      await this.initialize()
      await this.getAlumnos( )
    },

    methods: {
      initialize () {
      	this.cargar = true
        this.grupos = []
        return this.$http.get('grupos.list').then(response=>{

        	if( [19,93].includes( this.getdatosUsuario.id )){
        		
        		this.grupos = response.data //.filter( el => el.idplanteles == this.getdatosUsuario.idplanteles)

        	}else{
        		
        		this.grupos = response.data.filter( el => el.idplanteles == this.getdatosUsuario.idplanteles)

        	}
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      getAlumnos () {
      	this.cargar = true
        this.alumnos = []
        return this.$http.get('alumnos.list').then(response=>{
        	this.alumnos = response.data.filter( el => el.idplanteles == this.getdatosUsuario.idplanteles )
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },
      
      allowedDates( val ) {
		    // Retorna una función que Vuetify usa para filtrar fechas permitidas
	      const fecha = new Date(val);
	      const inicio = new Date(this.editedItem.fechainicio);
	      const fin = new Date(this.editedItem.fechafinal);

	      // Validar si está dentro del rango
	      if (fecha < inicio || fecha > fin) return false;

	      // Obtener el día de la semana (0: domingo, 1: lunes, ..., 6: sábado)
	      const diaSemana = fecha.getDay();

	      console.log( this.editedItem.sabado )

	      // Mapear a tus variables
	      const diasPermitidos = [
	        this.editedItem.lunes,     // 1
	        this.editedItem.martes,    // 2
	        this.editedItem.miercoles, // 3
	        this.editedItem.jueves,    // 4
	        this.editedItem.viernes,   // 5
	        this.editedItem.sabado,     // 6
	        this.editedItem.domingo   // 0
	      ];	

	      return diasPermitidos[diaSemana] === 1;
		  },

      editItemAlumnos (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

      	this.cargar = true
        this.inscritos = []

        return this.$http.get('grupos.alumnos/' + this.editedItem.idgrupos ).then(response=>{
        	this.inscritos = response.data
        	this.cargar      = false
        	this.dialogAlumnos = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      alumnosAsistencia(item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)

        this.fechaMin = this.editedItem.fechainicio
				this.fechaMax = this.editedItem.fechafinal

      	this.cargar = true
        this.listaalumnos = []

        let payload = {
        	fecha    : this.fecha_asistencia,
        	idgrupos : this.editedItem.idgrupos,
        	lunes    : this.editedItem.lunes,
        	martes   : this.editedItem.martes,
        	miercoles: this.editedItem.miercoles,
        	jueves   : this.editedItem.jueves,
        	viernes  : this.editedItem.viernes,
        	sabado   : this.editedItem.sabado,
        	domingo  : this.editedItem.domingo,
        	fechainicio : this.editedItem.fechainicio,
        	fechafinal : this.editedItem.fechafinal
        }


        return this.$http.post('grupos.alumnos.asistencia', payload ).then(response=>{
        	this.listaalumnos = response.data
        	this.cargar      = false
        	this.dialogAlumnosAsistencia = true
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })


      },

      deleteItem (item) {
        this.editedIndex = this.grupos.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemAlumnos( item ){

        this.deleteAlumno = Object.assign({}, item)
        this.dialogDeleteAlumno = true

      },

      deleteItemConfirm () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize () 
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      deleteItemConfirmAlumno () {
      	this.cargar = true
        // Lo mandapos por el EP
        this.deleteAlumno.deleted = 1
        this.$http.put('grupos.alumnos/' + this.deleteAlumno.idgruposalumnos, this.deleteAlumno).then(response=>{
          this.validarSuccess( response.data.message )
          this.editItemAlumnos (this.editedItem) 
          this.dialogDeleteAlumno = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeAlumnos () {
        this.dialogAlumnos = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
	      this.cargar = true

        if (this.editedIndex > -1) {
	        // Lo mandapos por el EP
          this.$http.put('grupos.update/' + this.editedItem.idgrupos, this.editedItem).then(response=>{
        		this.close()
          	this.validarSuccess( response.data.message )
          	this.initialize()
	        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('grupos.add', this.editedItem).then(response=>{
        		this.close()
          	this.initialize()
	        	this.cargar = false
	        }).catch( error =>{
          	this.validarError( error )
        	}).finally( () => { this.cargar = false })
        }
      },

      saveAlumno() {
	      this.cargar = true
	      this.alumno.idgrupos = this.editedItem.idgrupos
        // Lo mandapos por el EP
        this.$http.post('grupos.alumnos', this.alumno).then(response=>{
      		this.alumno = null
        	this.editItemAlumnos( this.editedItem )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })
      },

      enviarAsistencias( ){
      	this.cargar = true

      	const payload = {
      		idgrupos        : this.editedItem.idgrupos, 
      		idmaestros      : this.getdatosUsuario.id , 
      		alumnos         : this.listaalumnos, 
      		fecha_asistencia: this.fecha_asistencia
      	}

      	// Lo mandapos por el EP
        this.$http.post('grupos.asistencia.add', payload ).then(response=>{
      		this.alumno = null
      		this.validarSuccess('Asistencia actualizada')
        	this.alumnosAsistencia( this.editedItem )
        	this.cargar = false
        }).catch( error =>{
        	this.validarError( error )
      	}).finally( () => { this.cargar = false })

      }
    },
  }
</script>


